import webBiLogger from '@wix/web-bi-logger';

import BITransaction from '../lib/bi/BITransaction';

const biLogger = webBiLogger.factory({ trackSession: false }).logger();
const biTransaction = new BITransaction();

export { biLogger, biTransaction };
